export const comments_5588994 = {"data":{"data":[],"links":{}}}